<template>
  <div>
    <section v-if="this.searchObjects.length > 0">
      <div v-for="searchObject in searchObjects" v-bind:key="searchObject._id">
        <div class="d-flex competitionbox-holder mt-4">
          <FavouritesFundListDetails @search-object-change="handleRefresh($event)" :data="searchObject" />
        </div>
      </div>
    </section>

    <section v-else class="d-flex competitionbox-holder">
      <div class="col-6 d-flex align-items-center justify-content-center">
        <p class="no-favourites-text">Még nincsenek forráslisták elmentve a kedvencek közé!</p>
      </div>
      <div class="col-6">
        <img src="../../../assets/img/fundlist-background.png" alt="fundlist-background" class="background-image" />
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import FavouritesFundListDetails from './FavouritesFundListDetails.vue'
import * as SearchObjectApi from '../../../api/searchObject'
export default {
  data() {
    return {
      searchObjects: null
    }
  },
  name: 'FavouriteFundmapList',
  components: {
    FavouritesFundListDetails
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  methods: {
    handleRefresh(value) {
      if (value == true) {
        this.getSearchObjectsByUserId(this.getUser._id)
      }
    },
    async getSearchObjectsByUserId(userId) {
      this.searchObjects = await SearchObjectApi.getSearchObjectsByUserId(userId)
    }
  },
  async created() {
    this.getSearchObjectsByUserId(this.getUser._id)
  }
}
</script>
<style scoped>
.competitionbox-holder {
  padding: 20px;
  padding-top: 30px;
  min-height: 80px;
  background-color: #f7fbfc;
  border-radius: 8px;
  min-height: 80px;
  margin-bottom: 10px;
}
.background-image {
  width: 100%;
}
.no-favourites-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  color: #00903c;
  max-width: 300px;
}

@media (max-width: 992px) {
  .no-favourites-text {
    font-size: 16px;
  }
}
</style>
